import { motion, AnimatePresence } from "framer-motion";

const Loader = ({ isLoading }) => {
  return (
    <AnimatePresence>
      {isLoading && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="fixed inset-0 z-[9999] bg-slate-950 flex items-center justify-center"
          data-testid="loader-screen"
        >
          <div className="flex flex-col items-center gap-8">
            {/* Hexagon Logo Animation */}
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.5 }}
              className="relative"
            >
              {/* Hexagon SVG */}
              <svg
                width="100"
                height="115"
                viewBox="0 0 100 115"
                className="overflow-visible"
              >
                {/* Outer hexagon */}
                <motion.path
                  d="M50 0 L93.3 25 L93.3 75 L50 100 L6.7 75 L6.7 25 Z"
                  fill="none"
                  stroke="#D4AF37"
                  strokeWidth="2"
                  initial={{ pathLength: 0 }}
                  animate={{ pathLength: 1 }}
                  transition={{ duration: 1.5, repeat: Infinity, repeatType: "loop" }}
                />
                {/* Inner lines */}
                <motion.path
                  d="M50 15 L78.3 32.5 L78.3 67.5 L50 85 L21.7 67.5 L21.7 32.5 Z"
                  fill="none"
                  stroke="#D4AF37"
                  strokeWidth="1"
                  strokeOpacity="0.5"
                  initial={{ pathLength: 0 }}
                  animate={{ pathLength: 1 }}
                  transition={{ duration: 1.5, delay: 0.3, repeat: Infinity, repeatType: "loop" }}
                />
                {/* Number 1 */}
                <motion.text
                  x="50"
                  y="60"
                  textAnchor="middle"
                  fill="#D4AF37"
                  fontSize="36"
                  fontWeight="bold"
                  fontFamily="Manrope, sans-serif"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: [0, 1, 1, 0] }}
                  transition={{ duration: 2, repeat: Infinity }}
                >
                  1
                </motion.text>
              </svg>
            </motion.div>

            {/* Loading text */}
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
              className="text-center"
            >
              <p className="text-slate-400 text-sm tracking-widest uppercase font-medium">
                First Defense
              </p>
              <motion.div
                className="h-0.5 bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent mt-2"
                initial={{ width: 0 }}
                animate={{ width: 120 }}
                transition={{ duration: 1, repeat: Infinity, repeatType: "reverse" }}
              />
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Loader;
